export default "__VITE_ASSET__434eba29__"